import { request } from '../lib/apiClient'
import { toDate } from '../lib/format'

/**
 * Tasks — backend/tasks/app.py.
 * Permissioned with TASKS_VIEW / TASKS_CREATE / TASKS_EDIT / TASKS_DELETE.
 * Assignees are real `users` rows; the server rejects candidate-role accounts.
 */

export function list({ status, priority, assigneeId, top, skip } = {}) {
  return request('/tasks/fetch', {
    params: { status, priority, assignee_id: assigneeId, top, skip },
  })
}

export function create(body) {
  return request('/tasks/create', { method: 'POST', body })
}

export function update(taskId, body) {
  return request('/tasks/update', { method: 'PATCH', params: { task_id: taskId }, body })
}

export function remove(taskId) {
  return request('/tasks/delete', { method: 'DELETE', params: { task_id: taskId } })
}

/**
 * The assignee picker — active recruiter-role users only (role id resolved
 * from the roles table server-side). A dedicated endpoint so assigning a task
 * never needs rbac_users.view.
 */
export function listAssignees() {
  return request('/tasks/assignees/fetch')
}

/**
 * tasks row -> the shape Tasks.jsx renders. `done` folds the open|done status,
 * `due` becomes a Date for the overdue comparison (null = no deadline), and the
 * assignee is the real user's name with their role riding along.
 */
export function toTaskView(row) {
  return {
    id: row.id,
    title: row.title,
    done: row.status === 'done',
    priority: row.priority ? row.priority[0].toUpperCase() + row.priority.slice(1) : 'Medium',
    due: toDate(row.due_date),
    assignee: row.assignee_name || '—',
    assigneeRole: row.assignee_role || null,
    assigneeId: row.assignee_id,
    created: toDate(row.created_at),
  }
}
